export const pathPublicationPriceMap = "map";
export const pathPublicationPriceCalculations = "calculations";
export const pathPublicationPriceSummary = "summary";
